import React, { useEffect, useRef, useState } from 'react'
import { Helmet } from 'react-helmet'
import cell from '../../assets/img/aboutus_bg.jpg'
import goal from '../../assets/img/goal.png'
import vision from '../../assets/img/vision.jpg'
import a1 from '../../assets/img/a1.png'
import a2 from '../../assets/img/a2.png'
import a3 from '../../assets/img/a3.png'
import a4 from '../../assets/img/a4.png'
import a5 from '../../assets/img/a5.png'
import FooterSection from '../Footer'
import ConnectUs from '../../components/ConnectUs'
import Header from '../Header'
import TeamSection from '../../components/Team'
import { Text } from '../../components/Text'
import BottomSection from '../../components/BottomSection'
import pointer from '../../assets/img/landing/1.png'
import p2 from '../../assets/img/landing/2.png'
import p3 from '../../assets/img/landing/3.png'
import down from '../../assets/img/icon/arrow_down.png'
import blue_down from '../../assets/img/icon/blue_arrow.png'

const teams = [
  {
    id: 1,
    name: 'Э.Одхүү',
    job: 'Гүйцэтгэх захирал',
    title: 'Эх барих эмэгтэйчүүдийн эмч, Анагаах Ухааны доктор, Дэд профессор',
    education: [
      '1998 онд Булган аймгийн I арван жилийн сургууль, бүрэн дунд',
      '2004 онд ЭМШУИС, Хүний их эмч мэргэжлээр бакалавр',
      '2006 онд ЭМШУИС, “Гуурсан хоолойн архаг үрэвслийн сэдрэлийн үеийн гадаад амьсгалын үйл ажиллагаа ба ийлдсийн зарим цитокины өөрчлөлт” сэдвээр Анагаах Ухааны магистр ',
      '2011 онд “Монгол хүний насжих үйл явцад ийлдсийн антиоксидант болон прооксидант тогтолцооны оролцоог судалсан нь” сэдвээр Анагаах Ухааны доктор ',
      '2015 онд АШУҮИС, Эх барих, эмэгтэйчүүдийн эмч ',
      '2016 онд АШУҮИС, Дэд профессор '
    ],
    experiences: [
      '2005 – Одоог хүртэл АШУҮИС, Био-АС, Эмгэг физиологийн тэнхим, багш ',
      '2007 онд Судлаач эмч - Medical Chemistry Institute, Veterinary Medical School, Вен хот, Австри улс.',
      '2009-2010 онд Судлаач эмч, Medical Chemistry Institute, Veterinary Medical School, Вен хот, Австри улс. ',
      '2010 онд Үр хөврөл судлаач, Kato Ladies Clinic, Токио хот, Япон улс ',
      '2013-2015 онд Нөхөн үржихүй үргүйдлийн эмчилгээ, Kato Ladies Clinic, Токио хот, Япон улс ',
      '2015-2017 онд Өөжинмед үр шилжүүлэн суулгах эмнэлэг, Эмчилгээ эрхэлсэн захирал ',
      '2018 - Одоог хүртэл RMC үр шилжүүлэн суулгах үндэсний төв эмнэлгийн үүсгэн байгуулагч, Эмчилгээ эрхэлсэн захирал ',
      '2019 - Одоог хүртэл Селл Клиник эмнэлгийн (Реженератив Селл Сэнтр ХХК) үүсгэн байгуулагч, Гүйцэтгэх захирал'
    ],
    partnership: [
      'Монголын эх барих, эмэгтэйчүүдийн эмч нарын холбоо, удирдах зөвлөлийн гишүүн',
      'Монголын нөхөн үржихүйн анагаах ухаан, үргүйдэл судлалын нийгэмлэг, удирдах зөвлөлийн гишүүн ',
      'Committee member of the AOFOG Reproductive Endocrinology & Infertility Committee, ASIA & OCEANIA FEDERATION OF OBSTETRICS & GYNAECOLOGY ',
      'Member of the European Society of Human Reproduction and Embryology ',
      'Member of Asia Pacific Initiative on Reproduction'
    ],
    photo: a2
  },
  {
    id: 2,
    name: 'Ч. Гансүх',
    job: 'Судалгаа хөгжүүлэлт хариуцсан захирал',
    title: 'Эмнэлзүйн эмгэг судлаач эмч, Анагаах Ухааны доктор',
    education: [
      '1999 онд Нийслэлийн 84-р сургууль бүрэн дунд',
      '2005 онд ЭМШУИС, Хүний их эмч мэргэжлээр бакалавр',
      '2007 онд ЭМШУИС, “IFN гамма цитокин болон азотын дан ислийн атеросклерозын эмгэг жамд үзүүлэх нөлөө” сэдвээр Анагаах Ухааны магистр',
      '2017 онд Синика Академи, Тайван, “Гепатитын В вирусийн эсэд нэвтрэхэд гепарины нөлөө” сэдвээр Анагаах Ухааны доктор ',
      '2021 онд АШУҮИС, Эмнэлзүйн эмгэг судлаач эмч'
    ],
    experiences: [
      '2005 – 2007 онд ЭМШУИС, Био-АС Дархлаа судлалын тэнхим, Багш',
      '2017 – 2018 онд Синика Академи, Тайван, Постдоктор Фейлошип',
      '2018 – Одоог хүртэл АШУҮИС Био-АС, Дархлаа судлалын тэнхим, Багш',
      '2019 – Одоог хүртэл Селл Клиник эмнэлгийн (Реженератив Селл Сэнтр ХХК) үүсгэн байгуулагч, Судалгаа хөгжүүлэлт хариуцсан захирал'
    ],
    photo: a1
  },
  {
    id: 3,
    name: 'П.Ариунболд',
    job: 'ТУЗ-ын дарга',
    title: 'Хүний их эмч, Анагаах Ухаан, Бизнесийн удирдлагын магистр',
    education: [
      '2001 онд Булган аймгийн II арван жилийн сургуульд бүрэн дунд',
      '2007 онд ЭМШУИС – Хүний их эмч мэргэжлээр бакалавр',
      '2013 онд ЭМШУИС – "Уушгины өмөнтэй хүмүүст карциноген саармагжуулагч GCTT1, GSTM1 генийг илрүүлсэн дүн" сэдвээр Анагаах Ухааны магистр',
      '2018 онд СЭЗИС – “Орон нутгийн өмчит нэгдсэн эмнэлгийн засаглалыг сайжруулах нь” сэдвээр Бизнесийн удирдлагын магистр'
    ],
    experiences: [
      '2005 – Одоог хүртэл Эм Би Ти ХХК үүсгэн байгуулагч, Гүйцэтгэх захирал',
      '2009 – 2014 он Бид Монгол Экспресс ХХК үүсгэн байгуулагч, гүйцэтгэх захирал',
      '2015 – Одоог хүртэл  Икспель Монголиа ХХК үүсгэн байгуулагч',
      '2024 - Одоог хүртэл Старлинк Номад ХХК үүсгэн байгуулагч',
      '2019 - Одоог хүртэл Селл Клиник эмнэлгийн (Реженератив Селл Сэнтр ХХК) үүсгэн байгуулагч, ТУЗ-ын дарга'
    ],
    fb: 'https://www.facebook.com/ariunbold.purevsuren/',
    x: 'https://x.com/arnbld',
    insta: 'https://www.instagram.com/arnbld/',
    photo: a3
  },
  {
    id: 4,
    name: 'Т. Өлзийхүү',
    job: 'Эсийн өсгөврийн мэргэжилтэн',
    title: 'Био-Анагаах судлаач, Магистрант',
    photo: a4,
    education: [
      '2016 онд Ерөнхий боловсролын Оюуны Ундраа Цогцолбор сургууль, бүрэн дунд ',
      '2023 онд АШУҮИС, Био-Анагаах судлаач',
      '2024 онд АШУҮИС, Магистрант',
    ],
    experiences: [
      '2024 онд Сөүл эмнэлэг, Био-Анагаах судлаач ',
      '2024 - Одоог хүртэл Селл Клиник эмнэлгийн (Реженератив Селл Сэнтр ХХК) эсийн өсгөврийн мэргэжилтэн'
    ],
  },
  {
    id: 5,
    name: 'М. Мичидмаа',
    job: 'Эсийн өсгөврийн мэргэжилтэн',
    title: 'Био-Анагаах судлаач, Магистрант',
    photo: a5,
    education: [
      '2018 онд АШУҮИС-ийн харьяа лицей сургууль, бүрэн дунд',
      '2023 онд АШУҮИС, Био-Анагаах судлаач',
      '2023 онд АШУҮИС, Магистрант',
    ],
    experiences: [
      '2023 онд Интермэд эмнэлэг, Био-Анагаах судлаач',
      '2024 онд, RMC үр шилжүүлэн суулгах эмнэлэг, Био-Анагаах судлаач',
      '2024 - Одоог хүртэл Селл Клиник эмнэлгийн (Реженератив Селл Сэнтр ХХК) эсийн өсгөврийн мэргэжилтэн'
    ],
  }
]
export default function AboutUs () {
  const secondSection = useRef(null)
  const thirdSessionRef = useRef(null)
  const fourthSectionRef = useRef(null)
  const footerSectionRef = useRef(null)
  const [isScrolled, setIsScrolled] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50) // Adjust threshold as needed
    }

    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])
  // Scroll handler
  const scrollToSection = sectionRef => {
    if (sectionRef?.current) {
      sectionRef.current.scrollIntoView({ behavior: 'smooth' })
    }
  }
  return (
    <>
      <Helmet>
        <title>CellClinic - Banking and Therapy</title>
        <meta name='description' content='Cellbank' />
      </Helmet>

      <div>
        <div
          className='bg-gradient-to-l from-[#89E5D6] to-[#08393C] bg-cover bg-center bg-no-repeat h-[100vh] '
          style={{
            mixBlendMode: 'luminosity'
          }}
        >
          <div
            className={`fixed top-0 left-1/2 transform -translate-x-1/2 w-full  z-50 transition-all duration-300 ${
              isScrolled
                ? 'bg-blue shadow-md h-[7vh] top-2 max-w-[1440px] extraScreen:max-w-[1500px]'
                : 'bg-transparent h-[5vh]'
            }`}
          >
            <Header
              color={isScrolled ? 'black' : 'white'}
              gradientColor={isScrolled ? 'bg-white/90' : 'bg-none'}
            />
          </div>
          {/* <Header
            color='white'
          /> */}

          <div className='h-[100vh] flex flex-col  tablet:h-[100vh] maxScreen:max-w-[1440px]  extraScreen:max-w-[1660px] maxScreen:mx-auto extraScreen:mx-auto'>
            <div className='h-[82vh] flex-1 flex flex-row items-center justify-center gap-5 p-20 mt-20  mobile:mt-[-80px] mobile:gap-0 mobile:p-5 mobile:flex-col tablet:flex-col tablet:py-2 tablet:px-5'>
              <div className='w-1/2 mobile:w-full tablet:w-full tablet:h-1/2 tablet:flex tablet:justify-center tablet:flex-col tablet:p-20 '>
                <p className='text-4xl font-semibold text-white mobile:text-center tablet:text-center'>
                  Бидний тухай
                </p>
                <Text
                  className='text-white/75 mt-5 max-w-[700px] mobile:text-center text-[16px] 
              mobile:mb-4 mobile:text-[12px] tablet:max-w-full tablet:mb-4 maxScreen:max-w-[740px] '
                >
                  СЕЛЛ КЛИНИК эмнэлэг нь Монгол Улсад анх удаа ҮҮДЭЛ ЭСИЙН БАНК
                  болон ЭСИЙН ЭМЧИЛГЭЭНИЙ дэвшилтэт технологийг нэвтрүүлж, олон
                  улсын GMP стандартын дагуу эсийн боловсруулалт,
                  хадгалалтын үйлчилгээ үзүүлдэг. Мөн бид хавдрын
                  эрсдэлийг тодорхойлох, ургийн хромосомын эмгэгийг эрт илрүүлэх,
                  ховор өвчний ГЕНЕТИК ШИНЖИЛГЭЭНҮҮДИЙГ хийдэг.
                </Text>
              </div>
              <div className='w-1/2  mobile:w-full mobile:mt-5 tablet:w-[400px] tablet:h-1/2'>
                <div className='relative flex self-center bg-cover bg-center h-fit w-fit tablet:h-full rounded-2xl'>
                  <img src={cell} alt='dfd' className=' rounded-2xl' />
                </div>
              </div>
            </div>

            {/* Bottom Section */}
            <div className=' mobile:hidden tablet:hidden temp:mb-[-40px] mb-[-40px] hid'>
              <BottomSection
                pointer={pointer}
                down={down}
                scrollToSection={scrollToSection}
                nextRef={secondSection}
                d='M0,50 C300,450 900,-100 1100,160'
                width='100%'
                left={13}
              />
            </div>
          </div>
        </div>
        <div
          ref={secondSection}
          className='h-screen flex flex-col  bg-cover bg-center bg-no-repeat '
          style={{
            backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.65), rgba(0, 0, 0, 0.65)), url(${vision})`
          }}
        >
          <div className='w-full mobile:w-full tablet:w-full'>
            <section
              id='about'
              className='h-[90vh] flex flex-col justify-center items-center'
            >
              <p className='text-white text-[18px] font-normal text-center mt-[100px] mb-5'>
                Бидний уриа
              </p>
              <p className='text-white/85 text-[22px] font-light italic text-center'>
                Эсийг хадгална, эсээр эмчилнэ
              </p>
              <div className='flex flex-col justify-center items-center max-w-[550px]'>
                <p className='text-white text-[18px] font-normal text-center mt-[100px] '>
                  Бидний алсын хараа
                </p>
                <p className='text-white/85 text-[16px] font-light italic text-center mt-[30px] tracking-[1.1px] mobile:px-10'>
                  Эсийн эмчилгээний дэвшилтэт технологийг хөгжүүлэн олон улсын
                  магадлан итгэмжлэлээр хүлээн зөвшөөрөгдсөн, төв азийн
                  тэргүүлэгч эмнэлэг болно.
                </p>
              </div>
            </section>

            {/* Bottom Section */}
            <div className='h-[20vh] mt-[-60px] mobile:hidden tablet:hidden hid'>
              <BottomSection
                pointer={p2}
                down={down}
                scrollToSection={scrollToSection}
                nextRef={thirdSessionRef}
                d='M0,50 C300,450 900,-100 1100,160'
                width='80%'
                left={50}
              />
            </div>
          </div>
        </div>
      </div>
      <div
        ref={thirdSessionRef}
        className='h-[100vh] flex flex-col bg-white maxScreen:max-w-[1440px]  extraScreen:max-w-[1660px] maxScreen:mx-auto extraScreen:mx-auto'
      >
        <div className='max-h-[80vh] mobile:max-h-[100vh] flex-1 flex flex-row items-center justify-center mt-20 mobile:gap-0 mobile:mt-0 mobile:p-5 mobile:flex-col tablet:flex-col tablet:py-2 tablet:px-5'>
          <div className='w-[620px] mobile:w-full tablet:w-full ml-[80px] temp:ml-[80px] mr-20 mobile:p-0 mobile:ml-0 mobile:mr-0 tablet:ml-0 tablet:mr-0'>
            <p className='text-[36px] font-semibold text-[#215998] mobile:text-center tablet:text-center tablet:mb-20 mobile:mb-10 mobile:text-[16px]'>
              Бидний эрхэм зорилго
            </p>
            <Text
              className='text-[#181B2C] mt-5  mobile:text-justify text-[16px] 
              mobile:mb-4 mobile:text-[12px] tablet:max-w-[600px] tablet:ml-[100px] tablet:mb-4'
            >
              Үйлчлүүлэгчийн аюулгүй байдлыг эрхэмлэн дээдэлж, шинэ технологид
              суурилсан эсийн банк эсийн эмчилгээний өндөр үр дүнтэй, чанартай
              тусламж үйлчилгээг хүн амд үзүүлснээр Монгол гэр бүлийн амьдралын
              чанарыг дээшлүүлэх, эрүүл урт наслалтыг бий болгох.
            </Text>
          </div>
          <div className='w-2/3  mobile:w-full flex flex-col justify-end items-end p-[80px] temp:p-[80px] mobile:mt-5 mobile:p-0 tablet:p-0 tablet:w-[400px] mobile:h-[40vh] tablet:h-[40vh]'>
            <div className=' rounded-3xl  mobile:h-[300px]  tablet:h-[300px] mobile:self-center mobile:ml-5'>
              <img
                src={goal}
                className='h-full w-[660px] mobile:h-[300px] tablet:h-[450px] mobile:w-full tablet:w-full '
                alt='dfd'
              />
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className='h-[20vh] relative mobile:hidden tablet:hidden temp:mb-[-40px] hid'>
          {/* <div className='h-[20vh] mobile:hidden tablet:hidden mt-[-120px]'> */}
          <BottomSection
            pointer={p3}
            down={blue_down}
            scrollToSection={scrollToSection}
            nextRef={fourthSectionRef}
            d='M0,50 C300,450 900,-100 1100,160'
            width='60%'
            left={90}
            strokeColor='#215998'
          />
        </div>
      </div>
      <div
        ref={fourthSectionRef}
        className='h-screen about about-screen mobile:h-full tablet:h-full  flex flex-col justify-center bg-white'
      >
        <div
          className='max-h-[90vh] about-screen mobile:max-h-full tablet:max-h-full flex-1 flex flex-col items-center justify-center gap-5 p-10 
          mobile:gap-0 mobile:p-5  
         tablet:px-5 tablet:p-0'
        >
          <h4 className='mt-10 text-[#181B2C] text-[32px] font-bold text-center mobile:mb-8 mobile:mt-20 tablet:mt-20 '>
            Манай баг хамт олон
          </h4>
          {/* <div className='max-h-[90vh] relative overflow-hidden mobile:h-full  mobile:p-5 tablet:mt-24  mt-[-20px] mobile:mt-0'> */}
          <div className='h-[90vh] mobile:h-full mt-[-30px] tablet:h-full about-screen'>
            <TeamSection teams={teams}></TeamSection>
          </div>
          {/* <div className='mobile:p-5 relative mt-[-140px] ml-[270px] mobile:ml-0 tablet:ml-0 mobile:mt-0 tablet:mt-0'>
            <TeamSection teams={teams2}></TeamSection>
          </div> */}
        </div>

        {/* Bottom Section */}
        {/* <div className='h-[10vh] relative mobile:hidden ml-5'>
          <BottomSection
            pointer={p4}
            down={blue_down}
            scrollToSection={scrollToSection}
            nextRef={footerSectionRef}
            d='M0,50 C300,450 900,-100 1100,160'
            width='100%'
            left={13}
            strokeColor='#215998'
          />
        </div> */}
      </div>
      <div
        ref={footerSectionRef}
        className='mobile:h-full relative px-20 py-10 mobile:px-5 mobile:py-0  tablet:px-10 maxScreen:max-w-[1440px]  extraScreen:max-w-[1660px] maxScreen:mx-auto extraScreen:mx-auto'
      >
        <ConnectUs color='green'></ConnectUs>
        <FooterSection></FooterSection>
      </div>
    </>
  )
}
